export const endpoints = {
  // Auth
  providers: 'oauth2/providers',
  token: 'oauth2/token/',
  logout: 'oauth2/logout',

  // User
  users: 'users',
  users_crud: 'users/crud',
  user: 'user',
  user_management: 'user-management',

  countries: 'countries',
  roles: 'roles',
  projects_crud: 'projects/crud',
  projects: 'projects',
  project_statuses: 'project-statuses',
  classification_group: 'classification-group',
  classification: 'classification',
  branch: 'branch',
  question: 'question',
  questionnaire: 'questionnaire',
  attention_point: 'attention-point',
  action_plan: 'action-plan',
  files: 'files',
};
